import React, { useEffect, useState } from 'react';
import { Form, Input, Modal, Select, Button, notification, Spin, Checkbox, TreeSelect } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose } from '@fortawesome/free-solid-svg-icons';
import { useMutation } from '@apollo/client';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { resetGroup } from '@src/middleware/redux/reducers/group.reducer';
import { LoadingOutlined } from '@ant-design/icons';
import "@src/pages/setting/dataFields/modal/group.css";
import { newTaskGroupMutation, updateTaskGroupMutation } from '../../util/mutation/taskgroup.mutation';

export const GroupModal = ({ visible, onClose, groupRefetch, group}) => {
  
  const [groupName, setGroupName] = useState("");

  const [api, contextHolder] = notification.useNotification();
  const [btn, setbtn] = useState(true);
  const dispatch = useDispatch();

  useEffect(()=>{
    if(group && Object.keys(group)?.length>0){
      setGroupName(group?.name);
    }else{
      setGroupName("");
    }
  },[group]);
  console.log(group, "groupgroup")

  const [createGroup, { loading, error }] = useMutation(newTaskGroupMutation);

  const [updateGroup,{loading:updateGroupLoading}] = useMutation(updateTaskGroupMutation);

  

  const editGroup = async ()=>{
    if(Object.keys(group)){
      try{

        await updateGroup({variables:{ input: {_id: group?.key, name: groupName}}});
        onClose();
        api.success({
          message: "Group updated successfully",
          placement:"top",
          className: 'notification-without-close',
        });
        await groupRefetch();
        
        setGroupName(null);

        dispatch((resetGroup({})));
      }
      catch(err){
        
        api.error({
          message: err.message,
          placement:"top",
          className: 'notification-without-close',
        });
        // onClose();
      }
    }
  };

  const handelChange = (e)=>{
    setGroupName(e.target.value);
    if(e.target.value < 2){
      e.target.classList.add('input-control-error'); 
    }else{
      setbtn(false);
      e.target.classList.remove('input-control-error'); 
    }

  };

  const [localtab, setTab] = useState([]);

  useEffect(()=>{
    if(group?.tabs){
      setTab([...group?.tabs])
    }
  },[group]);


  const {authenticatedUserDetail} = useSelector(state=>state.userAuthReducer);   


  const handelSubmit = async() =>{
    try{

      await createGroup({

        variables: {
          input: {
            name: groupName,
            createdBy: authenticatedUserDetail?.employeeId
          }
        }

      });

      await groupRefetch();
      setGroupName(null);
      api.success({
        message: "Task Group has been created successfully",
        placement:"top",
        className: 'notification-without-close',
      });
      onClose();


    }
    catch(err){
      setGroupName(null);
      setbtn(true);
      api.error({
        message: err.message,
        placement:"top",
        className: 'notification-without-close',
      });
    }
  }





 

  return (
    <Modal
      visible={visible}
      width={500}
      footer={
        <div style={{padding:'26px 40px', textAlign:'left', display:'flex', columnGap:'16px', marginTop:'-25px' }}>
            <button  
              disabled={btn || loading || updateGroupLoading ||  groupName?.length<2 && true} 
              className={btn || loading || updateGroupLoading ||  groupName?.length < 2 ? 'disabled-btn drawer-filled-btn' : 'drawer-filled-btn'} 
              onClick={group?.name ? editGroup :handelSubmit}
            >
              {loading || updateGroupLoading? <Spin indicator={<LoadingOutlined/>}/> : "Save"}
            </button>
            <button  disabled={loading || updateGroupLoading} className={loading || updateGroupLoading? 'disabled-btn drawer-outlined-btn':'drawer-outlined-btn'} onClick={()=>{setTab([]); onClose(); }}>
              Cancel
            </button>
        </div>
      }
      closable={false}
    >
      
      <React.Fragment>
        {contextHolder}
        <div className='modal-header-title'>
            <span>{group?.name || updateGroupLoading ? 'Edit  ' : 'Create a new' } task group</span>
            <span  onClick={()=>{ setTab([]); onClose();}} ><FontAwesomeIcon className='close' icon={faClose}/></span>
        </div>
        <div className='modal-body'>
          
          <div className="text">
              You can create custom task groups to better organize any custom properties for each object.
          </div>

          <form id="branchForm" className='form group-tabs'>
            <Form.Item>
              <label>Name</label>
              <Input className={'input-control'} value={groupName} onChange={handelChange} name="groupName" />
            </Form.Item> 
                
          </form>
        </div>  
      </React.Fragment>  
    </Modal>
  );
};

